import React from 'react'
import { Navbar, Nav, Container } from 'react-bootstrap';


//import { render } from 'react-dom';

const Navigation = () => {
    return (
 
            <Navbar className='nav-bar' collapseOnSelect fixed='top' expand='xl'  variant='light'>
                <Container>
               
                    <Navbar.Toggle aria-controls='responsive-nabar-nav' />
                    <img className="imglogo" src="assets/img/Logo-NiveRama-Reflexologue.png" alt=""/>
                    <Navbar.Collapse id='responsive-navbar-nav'>
                        <Nav className='nav-text'>
                            <Nav.Link href='/'>Accueil</Nav.Link>
                            <Nav.Link href='/apropos'>Votre Réflexologue</Nav.Link>
                            <Nav.Link href='/reflexologie'>La Réflexologie</Nav.Link>
                            <Nav.Link href='/tarifs'>Tarifs</Nav.Link>
                            <Nav.Link href='/contact'>Contact</Nav.Link>

                        </Nav>
                        
                    </Navbar.Collapse>
                  
                </Container>
            </Navbar>
   


    );
}

export default Navigation